import { CSSProperties } from "react";

const light = {
  mainStyles: {
    "--bg-color": "#e5e5e5",

    "--outline-color": "#efefef",
    "--active-text-color": "#000",
    "--text-color": "#000",
    "--text-color-gray200": "#989898",
    "--strong-text-color": "#000",
    "--gradient-text-color":
      "linear-gradient(180deg, #FF9900 0%, #FF7100 100%)",
    "--hidden-text-color": "#a5a5a5",
    "--icon-fill-color": "#ff7100",

    "--backing-bg-color": "#202020",

    "--input-border-color": "#c5c5c5",
    "--input-active-border-color": "var(--strong-text-color)",
    "--input-error-color": "rgba(245, 46, 46, 0.8)",

    "--default-button-bg-color": "#bdbdbd",
    "--default-button-hover-bg-color": "#b0b0b0",
    "--default-button-icon-color": "var(--icon-fill-color)",

    "--delete-button-bg-color": "rgba(245, 46, 46, 0.1)",
    "--delete-button-hover-bg-color": "rgba(245, 46, 46, 0.3)",
    "--delete-button-icon-color": "#f52e2e",

    "--success-button-bg-color": "rgba(255, 113, 0, 0.2)",
    "--success-button-hover-bg-color": "rgba(255, 113, 0, 0.4)",
  } as CSSProperties,
  gaugeStyles: {
    "--box-shadow":
      "-4px -4px 8px rgba(255, 255, 255, 0.74), -1px -1px 4px rgba(255, 255, 255, 0.24), 1px 1px 2px rgba(131, 131, 131, 0.3), 4px 4px 8px rgba(138, 138, 138, 0.2)",
    "--bg-color": "#161616",
    "--control-bg-color": "#181818",
    "--control-border-color": "#FF7100",
    "--control-box-shadow":
      "inset -8px -8px 16px rgba(0, 0, 0, 0.12), inset -1px -1px 4px rgba(0, 0, 0, 0.24), inset 0px 0px 4px rgba(101, 101, 101, 0.12), inset 8px 8px 16px rgba(101, 101, 101, 0.12)",
  } as CSSProperties,
  sectionStyles: {
    "--separator-color": "#d0d0d0",
    "--bg-color": "#dddddd",
    "--icon-color": "#a5a5a5",
    "--cable-shadow-color": "#8d8b8b",
    "--box-shadow":
      "-4px -4px 8px rgba(255, 255, 255, 0.74), -1px -1px 4px rgba(255, 255, 255, 0.24), 1px 1px 2px rgba(131, 131, 131, 0.3), 4px 4px 8px rgba(138, 138, 138, 0.2)",
  } as CSSProperties,
  popupStyles: {
    "--bg-color": "#e5e5e5",
    "--separator-color": "#d0d0d0",
    "--default-button-hover-bg-color": "#d0d0d0",
  } as CSSProperties,
  dialogStyles: {
    "--box-shadow": "0px 8px 36px rgba(0, 0, 0, 0.16)",
    "--backing-bg-color": "#070707",
    "--default-button-bg-color": "#bdbdbd",
    "--default-button-hover-bg-color": "#b0b0b0",
    "--cancel-button-bg-color": "#dddddd",
    "--cancel-button-hover-bg-color": "#d0d0d0",
    "--cancel-button-border-color": "#d0d0d0",
  } as CSSProperties,
  instructionsStyles: {
    "--thumb-color": "#333333",
    "--bottom-color":
      "linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(253,253,253,1) 17%, rgba(229,229,229,1) 100%)",
  } as CSSProperties,
  leftSideStyles: {
    "--bg-color": "#eceaea",
    "--box-shadow": "0px 1px 2px rgba(131, 131, 131, 0.3)",
    "--separator-color": "#d0d0d0",
    "--header-button-bg-color": "#efefef",
  } as CSSProperties,
};

export default light;
